import React from 'react';
import { Icon } from './Icon';

// The one spinning thing. Reports grew five loading indicators — two of them
// sharing a card, three of them a bare rotate-cw icon that never turned — so the
// same wait looked like four different states depending on where you hit it.
//
// Longhand animation properties rather than the `animation` shorthand: jsdom does
// not expand the shorthand, so the shorthand form is untestable.
// label={null} makes it decorative: use that whenever the host is already a live
// region, so the wait is not announced twice.
export const Spinner: React.FC<{
  size?: number;
  color?: string;
  label?: string | null;
}> = ({ size = 20, color = 'var(--twilight-sky)', label = 'Loading' }) => (
  <span
    data-testid="spinner"
    {...(label === null
      ? { 'aria-hidden': true }
      : { role: 'status', 'aria-label': label })}
    style={{
      display: 'inline-flex',
      animationName: 'uiSpin',
      animationDuration: '.9s',
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite',
    }}
  >
    <Icon name="rotate-cw" size={size} color={color} />
  </span>
);

export default Spinner;
